import { render, staticRenderFns } from "./RewardsPayout.vue?vue&type=template&id=2b81104e&scoped=true"
import script from "./RewardsPayout.vue?vue&type=script&lang=js"
export * from "./RewardsPayout.vue?vue&type=script&lang=js"
import style0 from "./RewardsPayout.vue?vue&type=style&index=0&id=2b81104e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81104e",
  null
  
)

export default component.exports